import type { AxiosError, AxiosRequestConfig } from 'axios'

import type { RequestConfigExtra, ResponseBody } from '@/types'
import { RequestEnum } from '~#/http-enum.ts'
import instance from '@/utils/request.ts'

interface AxiosOptions<T> {
  url: string
  params?: T
  data?: T
}
async function instancePromise<R = any, T = any>(
  options: AxiosOptions<T> & RequestConfigExtra
): Promise<ResponseBody<R>> {
  try {
    const response = await instance.request(options)
    return response as ResponseBody<R>
  } catch (error) {
    throw error as AxiosError
  }
}
export function useGet<R = any, T = any>(
  url: string,
  params?: T,
  config?: AxiosRequestConfig & RequestConfigExtra
): Promise<ResponseBody<R>> {
  return instancePromise<R, T>({
    url,
    params,
    method: RequestEnum.GET,
    ...config,
  })
}

export function usePost<R = any, T = any>(
  url: string,
  data?: T,
  config?: AxiosRequestConfig & RequestConfigExtra
): Promise<ResponseBody<R>> {
  return instancePromise<R, T>({
    url,
    data,
    method: RequestEnum.POST,
    ...config,
  })
}

export function usePut<R = any, T = any>(
  url: string,
  data?: T,
  config?: AxiosRequestConfig & RequestConfigExtra
): Promise<ResponseBody<R>> {
  return instancePromise<R, T>({
    url,
    data,
    method: RequestEnum.PUT,
    ...config,
  })
}

export function useDelete<R = any, T = any>(
  url: string,
  data?: T,
  config?: AxiosRequestConfig & RequestConfigExtra
): Promise<ResponseBody<R>> {
  return instancePromise<R, T>({
    url,
    data,
    method: RequestEnum.DELETE,
    ...config,
  })
}
